<!-- <div class="program-feature-container" [ngStyle]="{'background-image': 'url(' + backgroundImage + ')', 'background-size': 'cover', 'background-position': 'center'}"> -->
<div class="program-feature-container">
    <div class="program-feature-content">
        <div class="feature-title">{{landingCMSData?.programFeatureTitle}}</div>

        <div class="program-card-container">
            <div *ngFor="let card of cardData" class="program-card">
                <div class="program-card-image-container">
                    <img [src]="'https:' + card.fields.cardImage.fields.file.url" alt="Card Image" class="program-card-image">
                </div>
                <div class="program-card-body">
                    <div class="program-card-title">{{ card.fields.cardTitle }}</div>
                    <div class="program-card-description">{{ card.fields.cardDesc }}</div>
                </div>
            </div>
        </div>
    </div>
</div>